import { getRoot } from "mobx-state-tree"

export const openingHoursFactoryViews = self => ({

})